module.exports = __webpack_public_path__ + "static/img/2_11_1.010b9ef8.jpg";